export default "__VITE_ASSET__Ctgl_ALd__"